import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
  limit: 12,
  hasMore: true,

  selectedEvent: "",
  selectedCategory: "",

  images: [],

  isUploading: false,
};

const galleryImagesSlice = createSlice({
  name: "galleryImages",
  initialState,
  reducers: {

    // =========================
    // RESET LIST (important)
    // =========================
    resetGalleryImages(state) {
      state.page = 1;
      state.hasMore = true;
      state.images = [];
    },

    // =========================
    // SET FILTERS
    // =========================
    setSelectedEvent(state, action) {
      state.selectedEvent = action.payload;
      state.page = 1;
      state.images = [];
      state.hasMore = true;
    },

    setSelectedCategory(state, action) {
      state.selectedCategory = action.payload;
      state.page = 1;
      state.images = [];
      state.hasMore = true;
    },

    // =========================
    // PAGINATION
    // =========================
    incrementPage(state) {
      state.page += 1;
    },

    // =========================
    // DATA MERGE (Infinite Scroll)
    // =========================
    appendGalleryImages(state, action) {
      const newImages = action.payload || [];

      state.images = [...state.images, ...newImages];

      if (newImages.length < state.limit) {
        state.hasMore = false;
      }
    },

    // =========================
    // UPLOAD UI STATE
    // =========================
    setUploading(state, action) {
      state.isUploading = action.payload;
    },
  },
});

export const {
  resetGalleryImages,
  setSelectedEvent,
  setSelectedCategory,
  incrementPage,
  appendGalleryImages,
  setUploading,
} = galleryImagesSlice.actions;

export default galleryImagesSlice.reducer;
